import React, { useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { baseurl } from "../baseurl";
import logo from "../assets/img/logos.png";
import login1 from "../assets/img/login1.png";

function Login() {
  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState(""); 
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const res = await axios.post(`${baseurl}adminLogin`, {
        email,
        password,
      });

      localStorage.setItem("admin_id", res.data.admin.id);
      localStorage.setItem("admin_uuid", res.data.admin.uuid);
      localStorage.setItem("admin_name", res.data.admin.name);
      localStorage.setItem("admin_role", res.data.admin.role);

      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "success",
        title: "Admin login successful",
        showConfirmButton: false,
        timer: 2000,
        background: "#28a745",
        color: "#ffffff",
      });

      setTimeout(() => {
        navigate("/dashboard");
      }, 1500);
    } catch (err) {
      console.error(err);
      const msg = err.response?.data?.error || "Login failed";

      setError(msg);
      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "error",
        title: msg,
        showConfirmButton: false,
        timer: 2500,
        background: "red",
        color: "#ffffff",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page-wrapper">
      <style>{`
        .login-page-wrapper {
          min-height: 100vh;
          display: flex;
          align-items: center;
          justify-content: center;
          background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
          font-family: 'Inter', sans-serif;
        }
        .main-auth-card {
          background: rgba(255, 255, 255, 0.95);
          backdrop-filter: blur(10px);
          border: 1px solid rgba(255, 255, 255, 0.2);
          box-shadow: 0 20px 40px rgba(0,0,0,0.1);
          border-radius: 24px;
          overflow: hidden;
          max-width: 1000px;
          width: 95%;
        }
        .auth-side-banner {
          background: #ffffff;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 40px;
        }
        .auth-side-banner img {
          max-width: 100%;
          filter: drop-shadow(0 10px 15px rgba(0,0,0,0.05));
          animation: float 6s ease-in-out infinite;
        }
        @keyframes float {
          0% { transform: translateY(0px); }
          50% { transform: translateY(-20px); }
          100% { transform: translateY(0px); }
        }
        .form-section {
          padding: 50px;
        }
        .brand-logo {
          width: 120px;
          margin-bottom: 30px;
        }
        .auth-title {
          font-weight: 800;
          color: #1a202c;
          letter-spacing: -0.5px;
          margin-bottom: 8px;
        }
        .auth-subtitle {
          color: #718096;
          font-size: 0.95rem;
          margin-bottom: 32px;
        }
        .custom-form-label {
          font-size: 0.85rem;
          font-weight: 600;
          color: #4a5568;
          margin-bottom: 8px;
        }
        .custom-input {
          padding: 12px 16px;
          border-radius: 12px;
          border: 1.5px solid #e2e8f0;
          transition: all 0.3s ease;
          font-size: 0.95rem;
        }
        .custom-input:focus {
          border-color: #4299e1;
          box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.15);
          outline: none;
        }
        .password-toggle-btn {
          border-top-right-radius: 12px !important;
          border-bottom-right-radius: 12px !important;
          border: 1.5px solid #e2e8f0;
          border-left: none;
          background: #fff;
          color: #718096;
        }
        .login-submit-btn {
          padding: 12px;
          border-radius: 12px;
          font-weight: 600;
          background: #2d3748;
          border: none;
          transition: all 0.3s ease;
          margin-top: 10px;
        }
        .login-submit-btn:hover {
          background: #1a202c;
          transform: translateY(-2px);
          box-shadow: 0 10px 15px rgba(0,0,0,0.1);
        }
        .login-submit-btn:disabled {
          background: #a0aec0;
        }
        @media (max-width: 991px) {
          .form-section { padding: 30px; }
        }
      `}</style>

      <div className="main-auth-card">
        <div className="row g-0">
          {/* Left Side - Form */}
          <div className="col-lg-6">
            <div className="form-section">
              <img src={logo} className="brand-logo" alt="Logo" />
              <h2 className="auth-title">Welcome Back, Admin</h2>
              <p className="auth-subtitle">Please enter your control panel credentials.</p>

              <form className="row g-3" onSubmit={handleSubmit}>
                <div className="col-12">
                  <label htmlFor="inputEmailAddress" className="custom-form-label">
                    Email Address
                  </label>
                  <input
                    type="email"
                    className="form-control custom-input"
                    id="inputEmailAddress"
                    placeholder="name@company.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>

                <div className="col-12">
                  <label htmlFor="inputPassword" className="custom-form-label">
                    Password
                  </label>
                  <div className="input-group">
                    <input
                      type={showPassword ? "text" : "password"}
                      className="form-control custom-input border-end-0"
                      id="inputPassword"
                      placeholder="••••••••"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      required
                    />
                    <button
                      type="button"
                      className="password-toggle-btn px-3"
                      onClick={() => setShowPassword(!showPassword)}
                    >
                      <i className={showPassword ? "bi bi-eye-fill" : "bi bi-eye-slash-fill"}></i>
                    </button>
                  </div>
                </div>

                {error && (
                  <div className="col-12">
                    <div className="small text-danger d-flex align-items-center">
                      <i className="bi bi-exclamation-circle-fill me-2"></i> {error}
                    </div>
                  </div>
                )}

                <div className="col-12 mt-4">
                  <div className="d-grid">
                    <button type="submit" className="btn btn-primary login-submit-btn" disabled={loading}>
                      {loading ? (
                        <>
                          <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                          Authenticating...
                        </>
                      ) : (
                        "Sign In"
                      )}
                    </button>
                  </div>
                </div>
              </form>
              
              <div className="text-center mt-5">
                <p className="text-muted small mb-0">&copy; 2026 Admin Dashboard Portal. All rights reserved.</p>
              </div>
            </div>
          </div>

          {/* Right Side - Visuals */}
          <div className="col-lg-6 d-none d-lg-block auth-side-banner">
            <div className="text-center">
              <img src={login1} alt="Secure Authentication Illustration" />
              <div className="mt-4 px-5">
                <h5 className="fw-bold text-dark">Enterprise Security</h5>
                <p className="text-muted small">Your session is encrypted and monitored for security purposes.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;